export default __webpack_public_path__ + "static/media/main_landing_img_2.bce78dcb.png";